export const ROLE_OPERATOR = "operator";
export const ROLE_CLIENT = "client";
export const VALID_ROLES = [
    ROLE_OPERATOR,
    ROLE_CLIENT
]

export const VideoCallLocalStreamType = {
    TYPE_LOCAL_VIDEO: 'TYPE_LOCAL_VIDEO',
    TYPE_LOCAL_SCREEN_SHARE: 'TYPE_LOCAL_SCREEN_SHARE',
}

export const VideoCallEvents = {
    VIDEO_TOGGLED: 'VIDEO_TOGGLED', // Triggered when the user disable the video
    AUDIO_TOGGLED: 'AUDIO_TOGGLED', // Triggered when the user disable the audio
    SOCKET_CONNECTED: 'SOCKET_CONNECTED', // Triggered when the webSocket is connected
    SOCKET_CLOSED: 'SOCKET_CLOSED', // Triggered when the webSocket is closed
    CALL_INITIALIZING: 'CALL_INITIALIZING', // Triggered when the call is starting
    CALL_INITIALIZED: 'CALL_INITIALIZED', // Triggered when the call is initialized
    CALL_RENEGOTIATING: 'CALL_RENEGOTIATING',
    CALL_ENDED: 'CALL_ENDED', // Triggered when the call has ended
    INCOMING_CALL: 'INCOMING_CALL', // Triggered when there is an incoming call
    INCOMING_CALL_REQUEST: 'INCOMING_CALL_REQUEST', // Triggered when there is an incoming call
    ANSWERING_CALL: 'ANSWERING_CALL', // Triggered when the target has answered the call
    LOCAL_STREAM_CHANGED: 'LOCAL_STREAM_CHANGED', // Triggered when local stream has changed
    REMOTE_STREAM_CHANGED: 'REMOTE_STREAM_CHANGED',
    SCREEN_SHARE_STOP: 'SCREEN_SHARE_STOP',
    SCREEN_SHARE_START: 'SCREEN_SHARE_START',
    CONNECTION_STATE_CHANGED: 'CONNECTION_STATE_CHANGED'
}

export const PeerConnectionState = {
    DISCONNECTED: 'DISCONNECTED',
    CONNECTING: 'CONNECTING',
    ERROR: 'ERROR',
    CONNECTED: 'CONNECTED',
    UNKNOWN: 'UNKNOWN'
}

export class VideoCall {

    // Handles the events
    eventTarget = new EventTarget();

    // Main properties
    threadToken;
    threadId;

    // Socket properties
    webSocket;

    // Webrtc properties
    prefferedDevices;
    peerConnection;
    rtcConfiguration = {
        iceServers: [
            {
                urls: "turns:turn.ikeasi.com:3478",
                username: "turn",
                credential: "ikeasi123",
            },
        ],
    };


    localStream;
    screenShareStream;
    remoteStream;
    currentVideoSender;
    remoteVideo= null;
    processedStream;
    preProcessedVideoTrack;
    processedVideoTrack;


    isVideoMuted = false;
    isAudioMuted = false;

    isCallInitialized = false;
    logsEnabled = false;
    // selfieSegmentation = null;

    constructor({ role = null, threadId = null, threadToken = null, socketUrl = null, socket = null, remoteVideoElement = null, localVideoElement = null, logsEnabled = false }) {
        if (VALID_ROLES.indexOf(role) < 0) {
            console.error("Invalid role");
            return;
        }
        if (!threadId || !threadToken) {
            console.error("Invalid thread configuration");
            return;
        }
        if (!socketUrl && !socket) {
            console.error("Invalid socket configuration");
            return;
        }
        // if (!remoteVideoElement) {
        //     console.error("Remote video not specified");
        //     return;
        // }
        // if (!localVideoElement) {
        //     console.error("Local video not specified");
        //     return;
        // }

        this.logsEnabled = logsEnabled;
        this.threadId = threadId;
        this.threadToken = threadToken;
        this.remoteVideo = remoteVideoElement;
        this.localVideo = localVideoElement;
        this.role = role;
        if (socket) {
            this.initializeWebSocket(socket)
        } else if (socketUrl) {
            this.initializeWebSocketByUrl(socketUrl)
        }
    }


    /**
     * Websocket connection initialization
     */
    initializeWebSocketByUrl(socketUrl) {
        this.initializeWebSocket(new WebSocket(socketUrl))
    }

    /**
     * Websocket connection initialization
     */
    initializeWebSocket(socket) {
        if (!socket instanceof WebSocket) {
            console.error("Invalid socket");
            return;
        }
        this.webSocket = socket;
        this.initializeWebSocketEvents();
    }

    /**
     * 
     */
    initializeWebSocketEvents() {
        this.webSocket.addEventListener('open', () => {
            if (this.role === ROLE_OPERATOR) {
                // connect to the ws with token 
                this.sendSocketMessage({ act: "operator_update" })
            }
            this.dispatchEvent(VideoCallEvents.SOCKET_CONNECTED);
        });
        this.webSocket.addEventListener('close', (error) => {
            this.webSocket = null;
            this.dispatchEvent(VideoCallEvents.SOCKET_CLOSED);
            // close chat?
        })

        this.webSocket.onerror = (evt) => {
            console.error("WebSocket error:", evt);
        };

        this.webSocket.addEventListener('message',(data)=>{
            this.onWebSocketMessage(data)
        }); 

        this.webSocket.addEventListener('error', (error) => {
            this.logMessage("WebSocket error:", error);
        });
    }

    /**
     * Websocket's onmessage handler
     * @param {*} wsmessage 
     * @returns 
     */
    onWebSocketMessage = (wsmessage) => {
        const message = JSON.parse(wsmessage.data);
        if (message.data == null || message.data.act == null) {
            return;
        }
        let type = message.type;

        // tmp fix, cms has a different object
        if(type == undefined && message.peerConnection != undefined){
            type = message.peerConnection.type;
            if(message.peerConnection.candidate != undefined){
                message.candidate = message.peerConnection.candidate;
            }
        }
        
        //this.logMessage(type, message);
        
        switch (type) {
            case "offer":
                this.handleOffer(message.peerConnection)
                break;
            case "reconnect-offer":
                this.handleReconnection(message.peerConnection)
                break;
            case "renegotiate":
                this.handleRenegotiation(message.peerConnection)
                break;
            case "answer":
                this.handleAnswer(message.peerConnection)
                break;
            case "candidate":
                this.getPeerConnection().addIceCandidate(new RTCIceCandidate(message.candidate));
                break;
            case "hangup":
                this.endCall();
                break;
            case 'calling':
                this.handleIncomingCallRequest(message);
                break;
            default:
                this.logMessage("Message type " + type + " not handled", message)
                break;

        }
    }

    /**
     * Returns an object containing the websocket's default data merged with the given extra_data
     * @param {object} extra_data 
     * @returns 
     */
    getSocketThreadData(extra_data) {
        let data = { data: { thread: this.threadId, token: this.threadToken, act: 'calling' } };
        return Object.assign(data, extra_data);
    }

    /**
     * Sends a message to the socket if the 
     * @param {object} data 
     */
    sendSocketMessage(data) {
        let fullData = this.getSocketThreadData(data)
        //console.log("SENDING SOCKET MESSAGE:", data.type)
        if (this.isSocketInitialized()) {
            this.webSocket.send(JSON.stringify(fullData))
        } else {
            console.warn("Message not sent, the socket is not connected")
        }
    }

    /**
     * Checks if the websocket has been initialized
     * @returns boolean
     */
    isSocketInitialized() {
        return this.webSocket != undefined && this.webSocket.readyState == this.webSocket.OPEN
    }


    /**
     ****** PeerConnection Configuration ****
     **/

    /**
      * Once the videoCall has been initialized and answered by both peers the property is set to true
      */
    setCallInitialized(initialized){
        this.isCallInitialized = initialized;
    }


    /**
     * Generates a new peerConnection with the default events
     */
    createPeerConnection() {
        this.peerConnection = new RTCPeerConnection(this.rtcConfiguration);
        this.peerConnection.ontrack = (event) => { this.onPeerConnectionTrack(event) };
        this.peerConnection.onicecandidate = (event) => { this.onPeerConnectionIceCandidate(event) };
        this.peerConnection.onnegotiationneeded = (event) => { 
            // If the call has already been initialized we handle the renegotiation events, as the first event is handled by "initializeCall"
            // Also the event will only be handled by the operator to prevent an infinite loop described by refs#3091215 (This is a temporary fix.)
            if( this.isCallInitialized 
                && this.role === ROLE_OPERATOR){
                this.renegotiateStream();
            }
        };
        this.peerConnection.onconnectionstatechange = ()=>{
            let connectionState = PeerConnectionState.UNKNOWN;
            switch (this.peerConnection.connectionState){
                case "new":
                case "connecting":
                    connectionState = PeerConnectionState.CONNECTING;
                  break;
                case "connected":
                    connectionState = PeerConnectionState.CONNECTED;
                  break;
                case "closed":
                case "disconnected":
                    connectionState = PeerConnectionState.DISCONNECTED;
                  break;
                case "failed":
                    connectionState = PeerConnectionState.ERROR;
                  break;
                default:
                    connectionState = PeerConnectionState.UNKNOWN;
                  break;
            }
            this.dispatchEvent(VideoCallEvents.CONNECTION_STATE_CHANGED, {state: connectionState, original_state: this.peerConnection.connectionState})
        }
    }

    /**
     * Event executed once this.peerConnection's ontrack event is triggered.
     * The event provides the remote video steaming
     * @param {*} event 
     */
    onPeerConnectionTrack(event) {
        if (event.streams.length == 0) {
            console.log("Event without streams", event)
            return;
        }
        event.streams[0].getTracks().forEach((track) => {
            this.getRemoteStream().addTrack(track);
        })

        this.dispatchEvent(VideoCallEvents.REMOTE_STREAM_CHANGED, {stream: this.getRemoteStream()})

    }

    /**
     * Gets an instance of MediaStream
     * @returns 
     */
    getRemoteStream() {
        if (!this.remoteStream) {
            this.remoteStream = new MediaStream();
        }
        return this.remoteStream;
    }

    /**
     * Event executed once this.peerConnection's onicecandidate event is triggered 
     * @param {*} event 
     */
    onPeerConnectionIceCandidate(event) {
        if (event.candidate) {
            // sends all the current peerconnection candidates to the other user by socket
            this.sendSocketMessage({ type: 'candidate', candidate: event.candidate });
        }
    }

    /**
     * Handles he websocket message containing a client's call
     * @param {RTCPeerConnection} remoteDescription 
     */
    handleOffer(remoteDescription) {
        this.getPeerConnection().setRemoteDescription(new RTCSessionDescription(remoteDescription));
        this.dispatchEvent(VideoCallEvents.INCOMING_CALL)
    }

    /**
     * Handles he websocket message containing a client call request
     * @param {RTCPeerConnection} remoteDescription 
     */
    handleIncomingCallRequest(data) {
        this.dispatchEvent(VideoCallEvents.INCOMING_CALL_REQUEST)
    }

    /**
     * Handles the "reconnect-offer" event triggered by the other peer after refreshing the page
     * @param {*} remoteDescription 
     */
    handleReconnection(remoteDescription){
        if(!this.isCallInitialized){
            this.hangUpCall();
            this.logMessage("Failed to reconnect, there is no current call")
            return;
        }
        this.clearPeerConnection();
        this.handleRenegotiation(remoteDescription);
    }

    /**
     * Handles the "renegotiate" event called when there's a change in the tracks or the connection 
     * @param {*} remoteDescription 
     */
    handleRenegotiation(remoteDescription){
        this.getPeerConnection().setRemoteDescription(new RTCSessionDescription(remoteDescription));
        this.answerCall(this.prefferedDevices)
    }

    /**
     * Handles he websocket message containing the response from an operator
     * @param {RTCPeerConnection} remoteDescription 
     */
    handleAnswer(remoteDescription) {
        this.getPeerConnection().setRemoteDescription(new RTCSessionDescription(remoteDescription));
        this.dispatchEvent(VideoCallEvents.ANSWERING_CALL)
        this.setCallInitialized(true);
    }

    /**
     * Returns a new peerConnection if there is no connection created or the previously created peerConnection
     * @returns {RTCPeerConnection}
     */
    getPeerConnection() {
        if (!this.peerConnection) {
            this.createPeerConnection()
        }
        return this.peerConnection
    }


    /**
     * Fetch the localStream from the mediaDevices.
     * Add the streaming to the peerConnection
     * @param {*} prefferedDevices 
     */
    async initLocalStream(prefferedDevices) {
        let peerConn = this.getPeerConnection()
        return navigator.mediaDevices.getUserMedia(prefferedDevices).then(async(stream) => {
            this.localStream = stream;
            this.localVideo = document.getElementById('localVideo');

            this.localStream.getAudioTracks().forEach(track => {
                track.enabled = !this.isAudioMuted;
            })

            this.localStream.getVideoTracks().forEach(track => {
                track.enabled = !this.isVideoMuted;
            })

            if(this.localVideo){
                this.localVideo.srcObject = stream;
            }
            this.localStream.getTracks()
                .forEach(
                    track => {
                        peerConn.addTrack(track, this.localStream)
                    }
                );
            // this.dispatchEvent(VideoCallEvents.LOCAL_STREAM_CHANGED, {stream: this.localStream , stream_type: VideoCallLocalStreamType.TYPE_LOCAL_VIDEO})
            // return stream
        })
    }

    async selfieSegmentationFunction(){

        const myImage = new Image(270 , 200);
        myImage.src = "../../images/backgrounds/fondo.jpg";
        let canvas = document.getElementById('output')
        let ctx = canvas.getContext('2d');

        const selfieSegmentation = new SelfieSegmentation({
            locateFile: (file) => `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`
        });

        selfieSegmentation.setOptions({ modelSelection: 1 });

        selfieSegmentation.onResults(results => {
            if (results.segmentationMask) {
                this.blurBackground(results.segmentationMask, this.localVideo, canvas, ctx, myImage);
            }
        });

        // Captura el stream del canvas solo UNA vez
        this.processedStream = canvas.captureStream(30);
        this.processedVideoTrack = this.processedStream.getVideoTracks()[0];

        const audioTracks = this.localStream.getAudioTracks();

        let peerConn = this.getPeerConnection();
        const videoSender = peerConn.getSenders().find(sender => sender.track.kind === 'video');

        if (videoSender) {
            await videoSender.replaceTrack(this.processedVideoTrack);
        } else {
            peerConn.addTrack(this.processedVideoTrack, this.processedStream);
        }

        const combinedStream = new MediaStream();
        combinedStream.addTrack(this.processedVideoTrack);
        audioTracks.forEach(track => combinedStream.addTrack(track));

        const detectFrame = async () => {
            try{
                await selfieSegmentation.send({ image: this.localVideo });
                requestAnimationFrame(detectFrame);
            }catch(e){
                console.warn('Error on selfie segmentation:', e)
            }
        };

        await detectFrame();

        this.dispatchEvent(VideoCallEvents.LOCAL_STREAM_CHANGED, {stream: combinedStream , stream_type: VideoCallLocalStreamType.TYPE_LOCAL_VIDEO})

    }

    blurBackground(segmentationMask, videoFrame, canvas, ctx, myImage) {

        const width = videoFrame.videoWidth || videoFrame.width;
        const height = videoFrame.videoHeight || videoFrame.height;

        canvas.width = width;
        canvas.height = height;

        ctx.clearRect(0, 0, width, height);

        // Dibuja la persona sin blur
        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(videoFrame, 0, 0, width, height);
        ctx.globalCompositeOperation = 'destination-in';
        ctx.drawImage(segmentationMask, 0, 0, width, height);

        // Dibuja el fondo con blur (sin usar máscara invertida)
        ctx.globalCompositeOperation = 'destination-over';
        ctx.filter = 'blur(15px)';
        ctx.drawImage(videoFrame, 0, 0, width, height);
        // ctx.drawImage(myImage, 0, 0, width, height);

        ctx.filter = 'none';
        ctx.globalCompositeOperation = 'source-over';
    }


    /**
     * This event is called when the stream needs to be renegotiated
     * triggered by peerConnection.onnegotiationneeded
     */
    renegotiateStream() {
        let peerConn = this.getPeerConnection()

        peerConn.createOffer({
            offerToReceiveAudio: true,
            offerToReceiveVideo: true
        }).then((offer) => {
            
            peerConn.setLocalDescription(offer);
            
            this.dispatchEvent(VideoCallEvents.CALL_RENEGOTIATING);

            this.sendSocketMessage({ type: 'renegotiate', peerConnection: offer })

        });

    }



    /**
     * Initializes a new call
     * @param {*} preferedDevicesConfig 
     */
    async initializeCall(preferedDevicesConfig = { video: false, audio: false }) {
        this.prefferedDevices = preferedDevicesConfig;
        this.dispatchEvent(VideoCallEvents.CALL_INITIALIZING);

        return this.initLocalStream(this.prefferedDevices).then(async () => {
            if(this.prefferedDevices.video){
                await this.awaitSelfieSegmentation();
                await this.selfieSegmentationFunction();
            }

            let peerConn = this.getPeerConnection()
            // Generate the offer making sure the audio and video channel are created
            peerConn.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            }).then((offer) => {
                
                peerConn.setLocalDescription(offer);
                
                this.dispatchEvent(VideoCallEvents.CALL_INITIALIZED);

                this.sendSocketMessage({ type: 'offer', peerConnection: offer })
            });
        });
    }

    async awaitSelfieSegmentation(){
        await new Promise(resolve => {
            this.localVideo.onloadedmetadata = () => {
                resolve(this.localVideo);
            };
        });
    }


    /**
     * Tries to reconnect an existing call after refreshing the website
     * @param {*} preferedDevicesConfig 
     * @returns 
     */
    async reconnectCall(preferedDevicesConfig = { video: false, audio: false }) {
        this.prefferedDevices = preferedDevicesConfig;
        return this.initLocalStream(this.prefferedDevices).then(async() => {
            if(this.prefferedDevices.video){
                await this.awaitSelfieSegmentation();
                await this.selfieSegmentationFunction();
            }

            let peerConn = this.getPeerConnection()
            // Generate the offer making sure the audio and video channel are created
            peerConn.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            }).then((offer) => {
                
                peerConn.setLocalDescription(offer);

                this.dispatchEvent(VideoCallEvents.CALL_INITIALIZED);
                
                this.sendSocketMessage({ type: 'reconnect-offer', peerConnection: offer })

            });
        });
    }

    /**
     * Answers an incoming call
     * @param {*} prefferedDevices 
     */
    async answerCall(prefferedDevices = { video: false, audio: false }) {
        this.dispatchEvent(VideoCallEvents.CALL_INITIALIZING);
        this.prefferedDevices = prefferedDevices;
        this.initLocalStream(prefferedDevices).then(async (response) => {
            console.log(prefferedDevices);
            if(this.prefferedDevices.video){
                await this.awaitSelfieSegmentation();
                await this.selfieSegmentationFunction();
            }

            let peerConn = this.getPeerConnection()
            peerConn.createAnswer().then((answer) => {
                peerConn.setLocalDescription(answer);

                this.sendSocketMessage({ type: 'answer', peerConnection: answer });

                this.dispatchEvent(VideoCallEvents.CALL_INITIALIZED);

                this.setCallInitialized(true);
            });

        });
    }


    /**
     * Launches the screen share modal and starts the screen sharing
     * @returns 
     */
    async shareScreen() {
        return navigator.mediaDevices.getDisplayMedia({ video: true })
            .then((screenStream) => {
                this.handleShareScreen(screenStream);
            });
    }

    /**
     * Handles the response from navigator.mediaDevices.getDisplayMedia
     * @param {*} screenStream 
     */
    async handleShareScreen(screenStream) {
        this.screenShareStream = screenStream;
        let peerConn = this.getPeerConnection();

        // Add the video share to the peerConnection or replace the existent one
        let shareScreenVideoTrack = screenStream.getVideoTracks()[0];
        const videoSender = peerConn.getSenders().find(s => s.track && s.track.kind === 'video');
        if (videoSender) {
            videoSender.replaceTrack(shareScreenVideoTrack);
        } else {
            // This will trigger the "peerConnection.onnegotiationneeded" when there's no video track, allowing the user to share the screen
            peerConn.addTrack(shareScreenVideoTrack, screenStream);
        }

        
        
        screenStream.oninactive = screenStream.onended = () => {
            this.stopScreenSharing();
        };
        
        this.dispatchEvent(VideoCallEvents.SCREEN_SHARE_START);
        this.dispatchEvent(VideoCallEvents.LOCAL_STREAM_CHANGED, {stream: screenStream, stream_type: VideoCallLocalStreamType.TYPE_LOCAL_SCREEN_SHARE})

    }

    /**
     * Stops the screen sharing
     */
    async stopScreenSharing() {
        if (this.screenShareStream) {
            let peerConn = this.getPeerConnection();
            // localStream.getTracks().forEach(track => track.stop());
            this.screenShareStream.getTracks().forEach(track => {
                track.stop()});


            const videoTrack = this.processedVideoTrack;
            if (videoTrack) {
                videoTrack.enabled = !this.isVideoMuted;
            }
            const sender = peerConn.getSenders().find(s => s.track && s.track.kind === 'video');
            if (sender && videoTrack) {
                // Replace the stream track with the previous local track
                await sender.replaceTrack(videoTrack);
            } else if (videoTrack) {
                // There was no track sender, so we add a new one
                peerConn.addTrack(videoTrack, this.localStream);
            } else{
                // There were no video streaming, so we just remove the share screen streaming
                peerConn.removeTrack(sender)
            }
        }
        this.dispatchEvent(VideoCallEvents.SCREEN_SHARE_STOP);

        this.dispatchEvent(VideoCallEvents.LOCAL_STREAM_CHANGED, {stream: this.processedStream , stream_type: VideoCallLocalStreamType.TYPE_LOCAL_VIDEO})
    }


    /**
     * Toggle the audio mute
     */
    toggleMute() {
        this.isAudioMuted = !this.isAudioMuted;
        this.localStream.getAudioTracks().forEach(track => {
            track.enabled = !this.isAudioMuted;
        })
        this.dispatchEvent(VideoCallEvents.AUDIO_TOGGLED, {active: !this.isAudioMuted});
    }

    /**
     * Toggle the video mute
     */
    toggleVideo() {
        this.isVideoMuted = !this.isVideoMuted;
        this.localStream.getVideoTracks().forEach(track => {
            track.enabled = !this.isVideoMuted;
        })
        this.dispatchEvent(VideoCallEvents.VIDEO_TOGGLED, {active: !this.isVideoMuted});
    }


    /**
     * Closes the current call and sends a signal through websocket to hangup the client
     */
    hangUpCall() {

        this.logMessage("Ending call");

        this.sendSocketMessage({ type: 'hangup' });

        this.endCall();

    }


    /**
     * Clears the peerConnection property and closes the connection
     */
    clearPeerConnection(){

        if (this.peerConnection) {
            this.peerConnection.close();
            this.peerConnection = null;
        }

        if (this.remoteStream) {
            this.stopStreamTracks(this.remoteStream);
            this.remoteStream = null;
        }


    }

    /**
     * Close the current call without notifying others
     * Use hangUpCall instead
     */
    endCall() {

        this.clearPeerConnection();

        if (this.localStream) {
            // Stop the local stream tracks so the devices get free
            this.stopStreamTracks(this.localStream);
            this.localStream = null;
        }

        if (this.screenShareStream) {
            this.stopStreamTracks(this.screenShareStream);
            this.screenShareStream = null;
        }

        if (this.processedStream) {
            this.stopStreamTracks(this.processedStream);
            this.processedStream = null;
        }

        // Clear local video element
        if (this.localVideo && this.localVideo.srcObject) {
            this.stopStreamTracks(this.localVideo.srcObject);
            this.localVideo.srcObject = null;
        }

        this.setCallInitialized(false);
        this.dispatchEvent(VideoCallEvents.CALL_ENDED);
        this.logMessage("Call ended");

    }

    /**
     * Stop all the stream tracks
     * @param {*} stream 
     */
    stopStreamTracks(stream){
        if(stream){
            stream.getTracks().forEach(function (track) {
                track.stop();
            });
        }
    }

    /**
     * Logs a message to the console
     * @param {*} message 
     */
    logMessage(message, data) {
        if(this.logsEnabled){
            console.log(message, data)
        }
    }

    /**
     * Dispatchs an event registered trough addEventListener
     * @param {string} eventName 
     * @param {Object} data 
     */
    dispatchEvent(eventName, data = {}) {
        this.logMessage("Dispatching event - "+eventName, data);
        this.eventTarget.dispatchEvent(new CustomEvent(eventName, { detail: data }));
    }

    /**
     * Registers an event
     * @param {String} eventName 
     * @param {Function} callback 
     */
    addEventListener(eventName, callback) {
        this.eventTarget.addEventListener(eventName, callback);
    }

    /**
     * Removes a previously registered event
     * @param {String} eventName 
     * @param {Function} callback 
     */
    removeEventListener(eventName, callback) {
        this.eventTarget.removeEventListener(eventName, callback);
    }
    
}

const KIND_AUDIO = "audioinput"
const KIND_AUDIO_OUT = "audiooutput"
const KIND_VIDEO = "videoinput"
export class DeviceSelection {

    selectVideo = false;
    selectAudioInput = false;
    selectAudioOutput = false;

    selectedVideoDeviceId = null;
    selectedAudioDeviceId = null;
    selectedAudioOutputDeviceId = null;

    availableDevices = [];
    onDevicesUpdated = null;
    deviceChangeInitialized = false;

    constructor({ selectVideo = false, selectAudioInput = false, selectAudioOutput = false }) {
        this.selectVideo = selectVideo;
        this.selectAudioInput = selectAudioInput;
        this.selectAudioOutput = selectAudioOutput;
    }

    /**
     * Get the currently active device options
     * @returns {Promise} 
     */
    async getDeviceOptions() {

        if (!this.deviceChangeInitialized) {
            navigator.mediaDevices.ondevicechange = (event) => {
                this.updateDeviceList();
            };
            this.deviceChangeInitialized = true;
        }

        return this.updateDeviceList();
    }

    /**
     * Ask the browser for the currently active device options
     * @returns {Promise} 
     */
    async updateDeviceList() {
        // We call navigator.mediaDevices.getUserMedia before fetching the enumeratedDevices as firefox doesn't return devices if the permissions have not been granted
        return navigator.mediaDevices.getUserMedia({ video: this.selectVideo, audio: this.selectAudioInput || this.selectAudioOutput })
            .then(stream => {
                // Stop all tracks so the camera doesn't stay marked as active on the device selection
                stream.getTracks().forEach(track => {
                    track.stop();
                })
            })
            .catch(error => {
                // If getUserMedia fails (permission denied, no devices, etc.), we still want to enumerate devices
                console.warn('getUserMedia failed, enumerating devices anyway:', error);
            })
            .then(() => {
                // Always enumerate devices, whether getUserMedia succeeded or failed
                return navigator.mediaDevices.enumerateDevices()
                    .then((data) => {
                        return this.gotDevices(data)
                    })
            })

    }

    /**
     * Event internally called once the updateDeviceList has fetched devices
     * @param {*} devicesInfo 
     * @returns 
     */
    gotDevices(devicesInfo) {
        this.availableDevices = devicesInfo.filter(device => {
            return device.deviceId.length > 0 &&
                (
                    (device.kind == KIND_AUDIO && this.selectAudioInput) ||
                    (device.kind == KIND_AUDIO_OUT && this.selectAudioOutput) ||
                    (device.kind == KIND_VIDEO && this.selectVideo)
                )
        });
        if (this.onDevicesUpdated != undefined) {
            this.onDevicesUpdated(this.availableDevices)
        }
        return this.availableDevices;
    }


    /**
     * Gets the selected device for getUserMedia
     * @returns 
     */
    getUserSelectedDevices() {
        let video = this.selectedVideoDeviceId ? { exact: true, deviceId: this.selectedVideoDeviceId } : true
        let audio = this.selectedAudioDeviceId ? { exact: true, deviceId: this.selectedAudioDeviceId } : true
        if (!this.selectVideo) {
            video = false;
        }
        if (!this.selectAudioInput) {
            audio = false;
        }
        return {
            video: video,
            audio: audio
        }
    }

    /**
     * Sets the videoDeviceId
     * @param {Object|String} device 
     */
    setSelectedVideoDevice(device) {
        if (device instanceof Object) {
            this.selectedVideoDeviceId = device.deviceId;
        } else {
            this.selectedVideoDeviceId = device;
        }
    }

    /**
     * Sets the audioDeviceId
     * @param {Object|String} device 
     */
    setSelectedAudioDevice(device) {
        if (device instanceof Object) {
            this.selectedAudioDeviceId = device.deviceId;
        } else {
            this.selectedAudioDeviceId = device;
        }
    }


    /**
     * Sets the audioDeviceId
     * @param {Object|String} device
     */
    setSelectedAudioOutputDevice(device) {
        if (device instanceof Object) {
            this.selectedAudioOutputDeviceId = device.deviceId;
        } else {
            this.selectedAudioOutputDeviceId = device;
        }
    }

    /**
     * Stop all active tracks (for cleanup when closing modal)
     */
    stopAllTracks() {
        // This method can be extended if we track streams in the future
        console.log('DeviceSelection: stopAllTracks called');
    }

}